import moment from 'moment-timezone'

const DEFAULT_TIMEZONE = 'UTC'

export function getUserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE
}

export function getUserTimezoneDisplayLabel() {
  return `Showing times in ${getUserTimezone()}`
}

export function formatUtcDateTime(value, format, emptyValueDisplay = '-') {
  if (!value) return emptyValueDisplay

  return moment.utc(value).tz(getUserTimezone()).format(format)
}
